export default {
    state: {
        courses: null,
        allCourses: null,
        featuredCourses: null,
        recommendedCourses: null,
        hasInterests: false,
    },
    mutations: {
        SET_COURSES(state, payload){
            state.courses = payload.data;
        },
        SET_COURSES_CATEGORIES(state, payload){
            state.allCourses = payload.all;
            state.featuredCourses = payload.featured;
            state.recommendedCourses = payload.recommended;
            state.hasInterests = payload.has_interests;
            // Set default courses to all for backwards compatibility
            state.courses = payload.all;
        },
        ADD_COURSES(state, payload){
            state.courses.push(...payload.data);
        },
    },
    actions: {
        loadCourses({commit}){
            let url = '/courses';
            
            return new Promise((resolve, reject)=>{
                window.axios.get(url).then(response=>{
                    // Handle new API response format
                    if (response.data.all) {
                        commit('SET_COURSES_CATEGORIES', response.data);
                    } else {
                        // Fallback for old format
                        commit('SET_COURSES', {data: response.data.data});
                    }
                    resolve(response);
                }).catch(error=>{
                    reject(error);
                })
            });
        },
        getCourse({commit}, payload){
            let url = '/courses/' + payload.id;
            
            return new Promise((resolve, reject)=>{
                window.axios.get(url).then(response=>{
                    resolve(response);
                }).catch(error=>{
                    reject(error);
                })
            });
        },
        loadSalaryReport({commit}){
            let url = '/history/salary';
            
            return new Promise((resolve, reject)=>{
                window.axios.get(url).then(response=>{
                    commit('SET_COURSES', {data: response.data.data});
                    resolve(response);
                }).catch(error=>{
                    reject(error);
                })
            });
        },
        enrollCourse({commit}, payload){
            let url = '/courses/' + payload.id + '/enroll';
            
            return new Promise((resolve, reject)=>{
                window.axios.post(url, payload.data).then(response=>{
                    resolve(response);
                }).catch(error=>{
                    reject(error);
                })
            });
        },
        updateCourseEnrollment({commit}, payload){
            let url = '/courses/' + payload.id + '/enroll';
            
            return new Promise((resolve, reject)=>{
                window.axios.put(url, payload.data).then(response=>{
                    resolve(response);
                }).catch(error=>{
                    reject(error);
                })
            });
        },
        finishEnrollment({commit}, payload){
            let url = '/courses/' + payload.id + '/finish';
            
            return new Promise((resolve, reject)=>{
                window.axios.post(url, payload.data).then(response=>{
                    resolve(response);
                }).catch(error=>{
                    reject(error);
                })
            });
        },
        requestLeave({commit}, payload){
            let url = '/enrollments/' + payload.enrollmentId + '/holidays';
            
            return new Promise((resolve, reject)=>{
                window.axios.post(url, payload.data).then(response=>{
                    resolve(response);
                }).catch(error=>{
                    reject(error);
                })
            });
        },
        getHolidays({commit}, payload){
            let url = '/enrollments/' + payload.enrollmentId + '/holidays';
            
            return new Promise((resolve, reject)=>{
                window.axios.get(url).then(response=>{
                    resolve(response);
                }).catch(error=>{
                    reject(error);
                })
            });
        },
        cancelHoliday({commit}, payload){
            let url = '/holidays/' + payload.holidayId;
            
            return new Promise((resolve, reject)=>{
                window.axios.delete(url).then(response=>{
                    resolve(response);
                }).catch(error=>{
                    reject(error);
                })
            });
        },
    }
}